// extracted by mini-css-extract-plugin
export default {"backgroundColor":"dashboard_backgroundColor__IrWwB","nohover":"dashboard_nohover__3nwkA","datefont":"dashboard_datefont__7WNFw"};